import React from 'react'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'

import Loadable from 'react-loadable'
import Loader from './components/Loader'

import * as ROUTES from './resources/appRoutes'

import * as Skeletons from './components/Skeletons'
import ParentScreener from './views/ParentScreenerView'
import { Spinner } from 'react-bootstrap'

const OnboardingView = Loadable({
  loader: () => import('./views/OnboardingView'),
  loading: (props) => <Skeletons.OnboardingViewSkeleton {...props} />,
  timeout: 5 * 1000,
})
// const RewardsView = Loadable({
//   loader: () => import('./views/RewardsView'),
//   // loader: () => import('./views/ComingSoonView'),
//   loading: (props) => <Skeletons.OnboardingViewSkeleton {...props} />,
//   timeout: 5 * 1000,
// })
const ComingSoonView = Loadable({
  loader: () => import('./views/ComingSoonView'),
  loading: (props) => <Skeletons.OnboardingViewSkeleton {...props} />,
  timeout: 5 * 1000,
})
// const RewardsHistoryView = Loadable({
//   loader: () => import('./views/RewardsHistoryView'),
//   loading: (props) => <Skeletons.OnboardingViewSkeleton {...props} />,
//   timeout: 5 * 1000,
// })
const OtpView = Loadable({
  loader: () => import('./views/OtpView'),
  loading: (props) => <Skeletons.OtpViewSkeleton {...props} />,
  timeout: 5 * 1000,
})
const HomepageView = Loadable({
  loader: () => import('./views/HomepageView'),
  loading: (props) => <Skeletons.HomePageSkeleton {...props} />,
  timeout: 5 * 1000,
})
const VideoListView = Loadable({
  loader: () => import('./views/VideoListView'),
  loading: (props) => <Skeletons.VideoListSkeleton {...props} />,
  timeout: 5 * 1000,
})
// const AppsView = Loadable({
//   loader: () => import('./views/AppsView'),
//   loading: (props) => <Skeletons.AppListSkeleton {...props} />,
//   timeout: 5 * 1000,
// })
// const UserProfileView = Loadable({
//   loader: () => import('./views/UserProfileView'),
//   loading: (props) => <Skeletons.ProfileSkeleton {...props} />,
//   timeout: 5 * 1000,
// })
const ProfileEditView = Loadable({
  loader: () => import('./views/ProfileEditView'),
  loading: (props) => <Skeletons.ProfileSkeleton {...props} />,
  timeout: 5 * 1000,
})
// const AvatarView = Loadable({
//   loader: () => import('./views/AvatarView'),
//   loading: () => <Loader />,
// })
// const UserJourneyView = Loadable({
//   loader: () => import('./views/UserJourneyView'),
//   loading: (props) => <Skeletons.JourneyViewSkeleton {...props} />,
//   timeout: 5 * 1000,
// })
const QuizView = Loadable({
  loader: () => import('./views/QuizView'),
  loading: (props) => <Skeletons.QuizSkeleton {...props} />,
  timeout: 5 * 1000,
})
const FAQListView = Loadable({
  loader: () => import('./views/FAQListView'),
  loading: (props) => <Skeletons.FAQViewSkeleton {...props} />,
  timeout: 5 * 1000,
})
// const FeedbackView = Loadable({
//   loader: () => import('./views/FeedbackView'),
//   loading: () => <Loader />,
// })
// const ReportCardView = Loadable({
//   loader: () => import('./views/ReportCardView'),
//   loading: (props) => <Skeletons.ResultCardSkeleton {...props} />,
//   timeout: 5 * 1000,
// })
const LeaderboardView = Loadable({
  loader: () => import('./views/LeaderboardView'),
  loading: (props) => <Skeletons.LeaderboardSkeleton {...props} />,
  timeout: 5 * 1000,
})
const ImageQuizView = Loadable({
  loader: () => import('./views/ImageQuizView'),
  loading: () => <Loader />,
})
// const AppUsageView = Loadable({
//   loader: () => import('./views/AppUsageView'),
//   loading: () => <Loader />,
// })
const LoginView = Loadable({
  loader: () => import('./views/LoginView'),
  loading: () => <Loader />,
  // timeout: 5 * 1000,
})
const JourneyView = Loadable({
  loader: () => import('./views/JourneyView'),
  loading: (props) => <Loader />,
  timeout: 5 * 1000,
})
const LegalView = Loadable({
  loader: () => import('./views/LegalView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

const ScratchPointsView = Loadable({
  loader: () => import('./views/ScratchPointsView'),
  loading: (props) => <Loader />,
  timeout: 5 * 1000,
})
// const ChildReportView = Loadable({
//   loader: () => import('./views/ChildReportView'),
//   loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
//   timeout: 5 * 1000,
// })
// const RewardsCompletionView = Loadable({
//   loader: () => import('./views/RewardsCompletionView'),
//   loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
//   timeout: 5 * 1000,
// })

const SelectAgeView = Loadable({
  loader: () => import('./views/ChildAgeView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

const OnBoardingRewardsView = Loadable({
  loader: () => import('./views/OnBoardingRewardsView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

const FamilyProgressView = Loadable({
  loader: () => import('./views/FamilyProgressView'),
  loading: (props) => <Skeletons.FamilySkeleton {...props} />,
  timeout: 5 * 1000,
})

const WorksheetView = Loadable({
  loader: () => import('./views/WorksheetView'),
  loading: (props) => <Skeletons.WorksheetSkeleton {...props} />,
  timeout: 5 * 1000,
})

const ParentScreenerView = Loadable({
  loader: () => import('./views/ParentScreenerView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

// const PointsAwardView = Loadable({
//   loader: () => import('./views/PointsScreenView'),
//   loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
//   timeout: 5 * 1000,
// })

const KidAssessmentView = Loadable({
  loader: () => import('./views/KidAssessmentView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

const WorksheetQuizView = Loadable({
  loader: () => import('./views/WorksheetQuizView'),
  loading: (props) => <Skeletons.QuizSkeleton {...props} />,
  timeout: 5 * 1000,
})

const HowToWinView = Loadable({
  loader: () => import('./views/HowToWinView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

const MonthlyWinnerView = Loadable({
  loader: () => import('./views/MonthyWinnerView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

const CertificateView = Loadable({
  loader: () => import('./views/CertificateView'),
  loading: (props) => <Skeletons.LegalViewSkeletons {...props} />,
  timeout: 5 * 1000,
})

export const publicRoutes = (firebase, showOnboarding) => {
  let url = window.location.pathname
  return (
    <Switch>
      <Redirect
        from={`/:${url}*(/+)`}
        to={window.location.pathname.slice(0, -1)}
      />
      <Route
        exact
        path={ROUTES.LOGIN_VIEW}
        render={(props) => <LoginView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.OTP_VIEW}
        render={(props) => <OtpView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.ONBOARDING_VIEW}
        render={(props) => <OnboardingView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.LEGAL_VIEW}
        render={(props) => <LegalView {...props} firebase={firebase} />}
      />

      <Route
        exact
        path="*"
        render={(props) => (
          <Redirect
            to={{
              pathname: ROUTES.ONBOARDING_VIEW,
            }}
          />
        )}
      />
    </Switch>
  )
}

const routes = (firebase, age) => {
  let url = window.location.pathname
  // const { pathname } = useLocation()
  return (
    <Switch>
      <Redirect
        from={`/:${url}*(/+)`}
        to={window.location.pathname.slice(0, -1)}
      />

      {/* <Route
        exact                          
        path={ROUTES.CHILD_REPORT_VIEW}
        render={(props) => <ChildReportView {...props} firebase={firebase} />}
      /> */}
      {/* <Route
        exact
        path={ROUTES.REWARDS_COMPLETION_VIEW}
        render={(props) => (
          <RewardsCompletionView {...props} firebase={firebase} />
        )}
      /> */}
      <Route
        exact
        path={ROUTES.REWARDS_VIEW}
        render={(props) => <ComingSoonView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.SCRATCH_POINTS}
        render={(props) => <ScratchPointsView {...props} firebase={firebase} />}
      />
      {/* <Route
        exact
        path={ROUTES.REWARDS_HISTORY_VIEW}
        render={(props) => (
          <RewardsHistoryView {...props} firebase={firebase} />
        )}
      /> */}
      <Route
        exact
        path={ROUTES.HOME_VIEW}
        render={(props) => <HomepageView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.VIDEOS_VIEW}
        render={(props) => <VideoListView {...props} firebase={firebase} />}
      />
      {/* <Route
        exact
        path={ROUTES.APPS_VIEW}
        render={(props) => <AppsView {...props} firebase={firebase} />}
      /> */}
      <Route
        exact
        path={ROUTES.QUIZ_VIEW}
        render={(props) => <QuizView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.JOURNEY_VIEW}
        render={(props) => <JourneyView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.LEADERBOARD_VIEW}
        render={(props) => <LeaderboardView {...props} firebase={firebase} />}
      />
      {/* <Route
        exact
        path={ROUTES.REPORT_CARD_VIEW}
        render={(props) => <ReportCardView {...props} firebase={firebase} />}
      /> */}
      {/* <Route
        exact
        path={ROUTES.PROFILE_VIEW}
        render={(props) => <UserProfileView {...props} firebase={firebase} />}
      /> */}
      <Route
        exact
        path={ROUTES.EDIT_PROFILE_VIEW}
        render={(props) => <ProfileEditView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.FAQS_VIEW}
        render={(props) => <FAQListView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path="/image-quiz"
        render={(props) => <ImageQuizView {...props} firebase={firebase} />}
      />
      {/* <Route
        exact
        path="/app-usage"
        render={(props) => <AppUsageView {...props} firebase={firebase} />}
      /> */}
      <Route
        exact
        path={ROUTES.LEGAL_VIEW}
        render={(props) => <LegalView {...props} firebase={firebase} />}
      />

      <Route
        exact
        path={ROUTES.CHILD_AGE_VIEW}
        render={(props) => <SelectAgeView {...props} firebase={firebase} />}
      />

      <Route
        exact
        path={ROUTES.FAMILY_PROGRESS_VIEW}
        render={(props) => (
          <FamilyProgressView {...props} firebase={firebase} />
        )}
      />

      <Route
        exact
        path={ROUTES.WORKSHEET_VIEW}
        render={(props) => <WorksheetView {...props} firebase={firebase} />}
      />

      <Route
        exact
        path={ROUTES.CERTIFICATE_VIEW}
        render={(props) => <CertificateView {...props} firebase={firebase} />}
      />

      {/* <Route
        exact
        path={ROUTES.POINTS_AWARD_VIEW}
        render={(props) => <PointsAwardView {...props} firebase={firebase} />}
      /> */}

      <Route
        exact
        path={ROUTES.ONBOARD_REWARDS}
        render={(props) => (
          <OnBoardingRewardsView {...props} firebase={firebase} />
        )}
      />

      <Route
        exact
        path={ROUTES.WORKSHEETQUIZ_VIEW}
        render={(props) => <WorksheetQuizView {...props} firebase={firebase} />}
      />

      <Route
        exact
        path={ROUTES.KID_ASSESSSMENT_VIEW}
        render={(props) => <KidAssessmentView {...props} firebase={firebase} />}
      />

      <Route
        exact
        path={ROUTES.PARENT_SCREENER_VIEW}
        render={(props) => (
          <ParentScreenerView {...props} firebase={firebase} />
        )}
      />

      <Route
        exact
        path={ROUTES.HOW_TO_WIN_VIEW}
        render={(props) => <HowToWinView {...props} firebase={firebase} />}
      />
      <Route
        exact
        path={ROUTES.MONTHLY_WINNER_VIEW}
        render={(props) => <MonthlyWinnerView {...props} firebase={firebase} />}
      />

      <Route
        exact
        path="*"
        render={(props) => (
          <Redirect
            to={{
              pathname: !age ? ROUTES.CHILD_AGE_VIEW : ROUTES.HOME_VIEW,
            }}
          />
        )}
      />
    </Switch>
  )
}

export default routes

{
  /* <Redirect
            to={{
              pathname: showOnboarding
                ? ROUTES.ONBOARDING_VIEW
                : ROUTES.LOGIN_VIEW,
            }}
          /> */
}
